<template>
  <div class="flex flex-wrap gap-x-12 gap-y-8 justify-center">

    <div class="text-lg text-center">
      <div class="font-bold">{{ $t('Na nás se můžete spolehnout') }}</div>
      {{ $t('Spoustu let a spokojených zákazníků stojí za námi.') }}
    </div>

    <div class="w-full text-center desktop:w-auto">
      <MoleculesButtonsButton :href="appConfig.externalLinks.heurekaCZ" target="_blank" :arrow-right="true" :ghost="true" class="relative mt-20 tablet:mt-0 tablet:pl-20">
        <img src="/img/logo-heureka.png" alt="Heureka - Rigad.cz" title="Heureka.cz" class="absolute left-[calc(50%-35px)] -top-[5.5rem] tablet:-left-5 tablet:-top-2" />
        {{ $t('Heureka recenze') }}
      </MoleculesButtonsButton>
    </div>

    <div class="w-full text-center desktop:w-auto">
      <MoleculesButtonsButton :href="appConfig.externalLinks.zboziCZ" target="_blank" :arrow-right="true" :ghost="true" class="relative mt-20 tablet:mt-0 tablet:pl-20">
        <img src="/img/logo-zbozi.png" alt="Zboží.cz - Rigad.cz" title="Zboží.cz" class="absolute left-[calc(50%-35px)] -top-[5.5rem] tablet:-left-5 tablet:-top-2" />
        {{ $t('Zbozi.cz recenze') }}
      </MoleculesButtonsButton>
    </div>

    <div class="w-full text-center desktop:w-auto">
      <MoleculesButtonsButton :href="cache.getPageUrl(32997)" target="_blank" :arrow-right="true" :ghost="true" class="relative mt-20 tablet:mt-0 tablet:pl-20">
        <img src="/img/logo-nsn.png" alt="NATO NSN" title="NATO NSN" class="absolute left-[calc(50%-35px)] -top-[5.5rem] tablet:-left-5 tablet:-top-2" />
        {{ $t('NCAGE 828DG') }}
      </MoleculesButtonsButton>
    </div>
  </div>
</template>
<script setup>

const cache = useCache();
const appConfig = useAppConfig();

</script>